import { Router } from '@angular/router';
import { LoaderService } from '../loader/loader.service';
import { LoginService } from '../login/login.service';
import * as i0 from "@angular/core";
import * as i1 from "../login/login.service";
import * as i2 from "../loader/loader.service";
import * as i3 from "@angular/router";
var UnauthGuard = /** @class */ (function () {
    function UnauthGuard(loginService, loaderService, router) {
        this.loginService = loginService;
        this.loaderService = loaderService;
        this.router = router;
    }
    UnauthGuard.prototype.canActivate = function (_route, _state) {
        var session = this.loginService.getStoredSession();
        if (!session || !this.loginService.hasActiveSession()) {
            return true;
        }
        var navigation = this.loginService.determinePostLoginNavigation(session);
        if (navigation && navigation.commands) {
            if (navigation.showLoader) {
                this.loaderService.show();
            }
            this.router.navigate(navigation.commands);
            return false;
        }
        return false;
    };
    UnauthGuard.ngInjectableDef = i0.defineInjectable({ factory: function UnauthGuard_Factory() { return new UnauthGuard(i0.inject(i1.LoginService), i0.inject(i2.LoaderService), i0.inject(i3.Router)); }, token: UnauthGuard, providedIn: "root" });
    return UnauthGuard;
}());
export { UnauthGuard };
